import useFeatureFlag, { FEATURE_FLAGS } from '@/utils/featureFlags';

export const useMyMoneyHsaWithdrawalFeatureFlag = () => {
  const isUseMyMoneyHsaWithdrawalEnabled = useFeatureFlag(FEATURE_FLAGS.USE_MY_MONEY_HSA_WITHDRAWAL);
  return { isUseMyMoneyHsaWithdrawalEnabled };
};
